import { Injectable } from '@angular/core';

import { ApiHttpClient } from '../../../infrastructure/infrastructure.module';

import { Observable } from 'rxjs';
import { api } from "@bayclubs/utils"
import { camps } from '../../models/models.generated';

@Injectable()
export class MembershipApiService {

    constructor(private http: ApiHttpClient) { }

    public search(request: camps.MembershipSearchRequest): Observable<api.OperationPagedResult<camps.MembershipInfo>> {
        return this.http.post<api.OperationPagedResult<camps.MembershipInfo>>("membership/search", request, false);
    }

    public searchDetails(request: camps.MembershipDetailsSearchRequest): Observable<api.OperationPagedResult<camps.MembershipDetails>> {
        return this.http.post<api.OperationPagedResult<camps.MembershipDetails>>("membership/searchDetails", request, false);
    }

}
